module.exports = __webpack_public_path__ + "static/sameworld-07963c09f15db88682853e5a1a352d25.png";